import { ExternalLink, Play } from 'lucide-react';
import type { GuideStep } from './types';

export const DEFAULT_GUIDE_STEPS: GuideStep[] = [
  {
    id: 'welcome',
    target: '[data-guide="dashboard-header"]',
    title: 'Welcome to your dashboard!',
    content:
      'This is your home base where you can see all your projects and get help improving your code.',
    position: 'auto',
    animation: 'glow',
    nextAction: 'manual',
    estimatedDuration: 30,
  },
  {
    id: 'quick-actions',
    target: '[data-guide="quick-actions"]',
    title: 'Quick Actions',
    content:
      'These buttons help you get started. Connect your code from GitHub, upload a file, or see your past results.',
    position: 'auto',
    animation: 'pulse',
    nextAction: 'manual',
    estimatedDuration: 45,
    actionButton: {
      text: 'Try Connect Project',
      action: () => {
        // This will be overridden in the component with actual navigate function
      },
      variant: 'secondary',
      icon: <ExternalLink className="w-3 h-3" />,
    },
  },
  {
    id: 'repositories',
    target: '[data-guide="repositories"]',
    title: 'Your Projects',
    content:
      "Your connected projects show up here. You can see if they're healthy and get new suggestions.",
    position: 'auto',
    animation: 'glow',
    nextAction: 'manual',
    estimatedDuration: 40,
  },
  {
    id: 'recent-analysis',
    target: '[data-guide="recent-analysis"]',
    title: 'Recent Reviews',
    content:
      "See your latest code reviews here. We'll show you what we found and how to make your code better.",
    position: 'auto',
    animation: 'pulse',
    nextAction: 'manual',
    estimatedDuration: 35,
  },
  {
    id: 'complete',
    target: '[data-guide="dashboard-header"]',
    title: "You're all set!",
    content:
      'Take your time exploring. If you need help again, just look for the help button in the top navigation.',
    position: 'auto',
    animation: 'bounce',
    nextAction: 'manual',
    estimatedDuration: 20,
    actionButton: {
      text: 'Start Using Dashboard',
      action: () => {
        // Focus on the first actionable element
        const firstAction = document.querySelector(
          '[data-guide="quick-actions"] button',
        ) as HTMLElement;
        if (firstAction) {
          firstAction.focus();
        }
      },
      variant: 'primary',
      icon: <Play className="w-3 h-3" />,
    },
  },
];
